import { error } from "@sveltejs/kit";
export const prerender = true;

export async function load({ fetch, url }) {
  // Strip any trailing slash so "/en/" doesn't fetch "/en/.json" (404).
  const path = url.pathname.replace(/(.)\/+$/, "$1");
  const route = path !== "/" ? path : "/index";
  const pageRequest = await fetch(url.origin + route + ".json");
  const page = await pageRequest.json();

  if (!page.error) {
    return {
      ...page
    };
  }
  throw error(404, "Not found");
}
